var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { class: "share-url " + "share-url--" + _vm.network.api_type },
    [
      _c(
        "label",
        {
          staticClass: "share-url-label",
          attrs: {
            for: "share-url-" + _vm.post.id + "-network-" + _vm.network.id
          }
        },
        [_c("i", { class: _vm.networkIconClass })]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.url,
            expression: "url"
          }
        ],
        attrs: {
          type: "url",
          name: "share-url-" + _vm.post.id + "-network-" + _vm.network.id,
          id: "share-url-" + _vm.post.id + "-network-" + _vm.network.id,
          disabled: _vm.urlDisabled
        },
        domProps: { value: _vm.url },
        on: {
          blur: _vm.shareUrlSubmitted,
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.shareUrlSubmitted.apply(null, arguments)
          },
          change: _vm.shareUrlUpdated,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.url = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.network.api_type == "twitter"
        ? _c(
            "div",
            { staticClass: "retweet-wrapper" },
            [
              _c("i", {
                staticClass: "fas fa-comment",
                on: {
                  click: function($event) {
                    _vm.urlOnlySwitch = false
                    _vm.urlUpdated = true
                  }
                }
              }),
              _vm._v(" "),
              _c("switches", {
                attrs: { "emit-on-mount": "false" },
                model: {
                  value: _vm.urlOnlySwitch,
                  callback: function($$v) {
                    _vm.urlOnlySwitch = $$v
                  },
                  expression: "urlOnlySwitch"
                }
              }),
              _vm._v(" "),
              _c("i", {
                staticClass: "fas fa-retweet",
                on: {
                  click: function($event) {
                    _vm.urlOnlySwitch = true
                    _vm.urlUpdated = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }